
import { useI18n } from "vue-i18n";
import { defineComponent, ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import { Field, Cell, Icon, ActionSheet } from "vant";
import "@vant/touch-emulator";
import { OptionObject } from "../views/cashier_auto/interface";

export default defineComponent({
  name: "SELECT",
  props: ["list", "index", "modelValue", "fieldName"],
  emits: ["update:modelValue", "change"],
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet
  },
  setup(props, content) {
    const route = useRoute();
    const { t } = useI18n();
    const showSheet = ref(false);
    const search = ref("");

    const onSelectHandler = val => {
      showSheet.value = false;
      content.emit("update:modelValue", val.key);
      content.emit("change", {
        fieldName: props.fieldName,
        list: props.list,
        value: val
      });
    };

    /**
     * 下拉列表框
     */
    const dataList = computed(() => {
      let data = props.list;
      if (search.value) {
        data = data.filter(x => {
          return x.value.toLocaleLowerCase().includes(search.value.toLocaleLowerCase());
        });
      } else {
        return props.list;
      }
      return data;
    });

    /**
     * 通过编码查找对应的名称
     * @param code 编码Code
     * @param list 列表数据
     */
    const getNameByCode = (code: string, data: Array<OptionObject>) => {
      return (
        data.find((x: OptionObject) => {
          return x.key == code;
        })?.value || ""
      );
    };

    onMounted(() => {});

    return {
      search,
      dataList,
      getNameByCode,
      showSheet,
      onSelectHandler
    };
  }
});
